import {createReducer, Reducer} from "redux-act";
import {OddsType} from "modules/constants/enums";
import {switchOddsType} from "modules/actions";

export const odds: Reducer<OddsType> = createReducer({}, OddsType.HeadToHead).on(
	switchOddsType,
	(_state, newOddsType) => newOddsType
);
